import { useEffect, useState } from "react"
import { api, type CurrentUser } from "./api"
import { JobsView } from "./JobsView"
import { TokensView } from "./TokensView"
import { SettingsView } from "./SettingsView"

type Tab = "jobs" | "tokens" | "settings"

function LoginScreen() {
    return (
        <div className="login-screen">
            <h1>Sentinel</h1>
            <p>Sign in with your Marichi Solutions account to continue.</p>
            <a className="button" href="/auth/google/login">
                Sign in with Google
            </a>
        </div>
    )
}

export function App() {
    const [user, setUser] = useState<CurrentUser | null | undefined>(undefined)
    const [tab, setTab] = useState<Tab>("jobs")

    useEffect(() => {
        api.me()
            .then(setUser)
            .catch(() => setUser(null))
    }, [])

    if (user === undefined) return null // avoid a login-screen flash while /auth/me resolves
    if (user === null) return <LoginScreen />

    return (
        <div className="app">
            <header className="app-header">
                <h1>Sentinel</h1>
                <nav>
                    <button className={tab === "jobs" ? "tab active" : "tab"} onClick={() => setTab("jobs")}>
                        Jobs
                    </button>
                    <button className={tab === "tokens" ? "tab active" : "tab"} onClick={() => setTab("tokens")}>
                        API Tokens
                    </button>
                    <button className={tab === "settings" ? "tab active" : "tab"} onClick={() => setTab("settings")}>
                        Settings
                    </button>
                    <a className="tab" href="/docs" target="_blank" rel="noreferrer">
                        API Docs
                    </a>
                </nav>
                <div className="user-info">
                    <span>{user.email}</span>
                    <button
                        className="link-button"
                        onClick={() => api.logout().then(() => setUser(null))}
                    >
                        Sign out
                    </button>
                </div>
            </header>
            <main>
                {tab === "jobs" && <JobsView />}
                {tab === "tokens" && <TokensView />}
                {tab === "settings" && <SettingsView />}
            </main>
        </div>
    )
}
